import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/** Password field with show/hide toggle — hides native browser reveal via input-dark CSS. */
export function PasswordInput({
    value,
    onChange,
    className = "",
    inputClassName = "input-dark w-full rounded-md px-3 py-2 pr-10 text-sm",
    testId,
    autoComplete = "current-password",
    placeholder = "Password",
    required = false,
}) {
    const [show, setShow] = useState(false);

    return (
        <div className={`relative ${className}`.trim()}>
            <input
                type={show ? "text" : "password"}
                value={value}
                onChange={onChange}
                required={required}
                autoComplete={autoComplete}
                placeholder={placeholder}
                className={inputClassName}
                data-testid={testId}
            />
            <button
                type="button"
                onClick={() => setShow((v) => !v)}
                className="absolute inset-y-0 right-3 my-auto text-white/40 transition-colors hover:text-white"
                tabIndex={-1}
                aria-label={show ? "Hide password" : "Show password"}
                data-testid={testId ? `${testId}-toggle` : undefined}
            >
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
        </div>
    );
}
